import { Link } from 'react-router';

function NavMetaPages() {
  return (
    <ul>
      <li>
        <Link to={'/legal/terms'}>Terms of Use</Link>
      </li>
      <li>
        <Link to={'/legal/data'}>Data Accuracy and Attribution</Link>
      </li>
    </ul>
  );
}

export default NavMetaPages
